import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import Facebook from '../../../assets/images/icon/fb.svg'
import Twitter from '../../../assets/images/icon/tw.svg'
import Linkedin from '../../../assets/images/icon/lind.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faGlobe } from '@fortawesome/free-solid-svg-icons'
import constant from '../../../constant'
import { editProfileFormData, uploadEmpHeader, uploadEmplogo } from '../../../action/profile'
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from 'react-toastify';
import { validateFunctionalForm } from '../../../utils'


const EditProfile = ({ data, onSubmit, setShowLoader }) => {

    const [state, setState] = useState({
        primaryEmail: {
            name: "primaryEmail",
            value: data ? data.EMAIL : "",
            options: [],
            error: [],
            isRequired: true,
        },
        secondryEmail: {
            name: "secondryEmail",
            value: data ? data.SECONDARY_EMAIL : "",
            options: [],
            error: [],
            isRequired: false,
        },
        role: {
            name: "role",
            value: data ? data.EMPLOYER_ROLE_ID : "",
            options: [],
            error: [],
            isRequired: true,
        },
        mobile: {
            name: "mobile",
            value: data ? data.MOBILE : "",
            options: [],
            error: [],
            isRequired: true,
        },
        location: {
            name: "location",
            value: data ? data.LOCATION : "",
            options: [],
            error: [],
            isRequired: false,
        },
        companyName: {
            name: "companyName",
            value: data ? data.COMPANY_NAME : "",
            options: [],
            error: [],
            isRequired: true,
        },
        companyType: {
            name: "companyType",
            value: data ? data.COMPANY_TYPE_ID : "",
            options: [],
            error: [],
            isRequired: true,
        },
        industryType: {
            name: "industryType",
            value: data ? data.EMPLOYER_INDUSTRY_ID : "",
            options: [],
            error: [],
            isRequired: true,
        },
        contactPerson: {
            name: "contactPerson",
            value: data ? data.CONTACT_PERSON : "",
            options: [],
            error: [],
            isRequired: true,
        },
        contactPersonDesignation: {
            name: "contactPersonDesignation",
            value: data ? data.CONTACT_PERSON_DESIGNATION : "",
            options: [],
            error: [],
            isRequired: false,
        },
        websiteUrl: {
            name: "websiteUrl",
            value: data ? data.WEBSITE : "",
            options: [],
            error: [],
            isRequired: true,
        },
        phone1: {
            name: "phone1",
            value: data ? data.PHONE_1 : "",
            options: [],
            error: [],
            isRequired: false,
        },
        phone2: {
            name: "phone2",
            value: data ? data.PHONE_2 : "",
            options: [],
            error: [],
            isRequired: false,
        },
        faxNumber: {
            name: "faxNumber",
            value: data ? data.FAX_NUMBER : "",
            options: [],
            error: [],
            isRequired: false,
        },
        companyLogo: {
            name: "companyLogo",
            value: data ? data.COMPANY_LOGO : "",
            options: [],
            error: [],
            isRequired: true,
        },
        companyHeaderBackground: {
            name: "companyHeaderBackground",
            value: data ? data.COMPANY_HEADER_BACKGROUND : "",
            options: [],
            error: [],
            isRequired: false,
        },
        facebookPageUrl: {
            name: "facebookPageUrl",
            value: data ? data.FB_URL : "",
            options: [],
            error: [],
            isRequired: false,
        },
        linkedinProfileUrl: {
            name: "linkedinProfileUrl",
            value: data ? data.LINKEDIN_URL : "",
            options: [],
            error: [],
            isRequired: false,
        },
        twitterUrl: {
            name: "twitterUrl",
            value: data ? data.TWITTER_URL : "",
            error: [],
            isRequired: false,
        },
        companySize: {
            name: "companySize",
            value: data ? data.COMPANY_SIZE : "",
            options: [],
            error: [],
            isRequired: true,
        },
        founded: {
            name: "founded",
            value: data ? data.FOUNDED : "",
            options: [],
            error: [],
            isRequired: false,
        },
        headquarters: {
            name: "headquarters",
            value: data ? data.HEADQUARTERS : "",
            options: [],
            error: [],
            isRequired: false,
        },
        aboutCompany: {
            name: "aboutCompany",
            value: data ? data.ABOUT_COMPANY : "",
            options: [],
            error: [],
            isRequired: false,
        },
        pinCode: {
            name: "pinCode",
            value: data ? data.PINCODE : "",
            options: [],
            error: [],
            isRequired: true,
        },
        companyCategory: {
            name: "companyCategory",
            value: data ? data.EMPLOYER_CATEGORY : "",
            options: [],
            error: [],
            isRequired: true,
        }
    })

    const onHeaderUpload = (e) => {
        e.preventDefault();
        setShowLoader(true)
        let model = new FormData();
        let file = e.target.files[0]
        const imageMimeType = /image\/(png|jpg|jpeg)/i;
        if (!file.type.match(imageMimeType)) {
            toast.error("Please upload PNG / JPG / JPEG only");
            setState((prevState) => ({
                ...prevState,
                ['companyHeaderBackground']: {
                    ...prevState['companyHeaderBackground'],
                    value: '',
                },
            }));
            setShowLoader(false)

            return;
        } else {
            model.append("file", e.target.files[0]);
            uploadEmpHeader(model).then((res) => {
                if (res.status) {
                    toast.success('Header Uploaded Successfully')
                    setState((prevState) => ({
                        ...prevState,
                        ['companyHeaderBackground']: {
                            ...prevState['companyHeaderBackground'],
                            value: res.result.fileName,
                        },
                    }));
                } else {
                    toast.error(res.error);
                }
            }).finally(() => {
                setShowLoader(false)

            });
        };
    };
    const onPictureUpload = (e) => {
        e.preventDefault();
        setShowLoader(true)

        let model = new FormData();
        let file = e.target.files[0]
        const imageMimeType = /image\/(png|jpg|jpeg)/i;
        if (!file.type.match(imageMimeType)) {

            toast.error("Please upload PNG / JPG / JPEG only");
            setState((prevState) => ({
                ...prevState,
                ['companyLogo']: {
                    ...prevState['companyLogo'],
                    value: '',
                },
            }));
            setShowLoader(false)

        } else {
            model.append("file", e.target.files[0]);
            uploadEmplogo(model).then((res) => {
                if (res.status) {
                    toast.success('Logo Uploaded Successfully')
                    setState((prevState) => ({
                        ...prevState,
                        ['companyLogo']: {
                            ...prevState['companyLogo'],
                            value: res.result.fileName,
                        },
                    }));
                } else {
                    toast.error(res.error);
                }
            }).finally(() => {
                setShowLoader(false)

            });
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
            },
        }));
    };
    const setOptions = (name, newOptions) => {
        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                options: newOptions,
            },
        }));
    };

    const handleSubmit = () => {
        if (validateFunctionalForm(state, setState)) {

            const model = {
                primaryEmail: state.primaryEmail.value,
                SECONDARY_EMAIL: state.secondryEmail.value,
                EMPLOYER_ROLE_ID: state.role.value,
                mobile: formatPhoneNumberIntl(state.mobile.value),
                LOCATION: state.location.value,
                companyName: state.companyName.value,
                EMPLOYER_INDUSTRY_ID: state.industryType.value,
                CONTACT_PERSON: state.contactPerson.value,
                WEBSITE: state.websiteUrl.value,
                PHONE_1: state.phone1.value,
                PHONE_2: state.phone2.value,
                COMPANY_LOGO: state.companyLogo.value,
                COMPANY_HEADER_BACKGROUND: state.companyHeaderBackground.value,
                FB_URL: state.facebookPageUrl.value,
                LINKEDIN_URL: state.linkedinProfileUrl.value,
                TWITTER_URL: state.twitterUrl.value,
                COMPANY_SIZE: state.companySize.value,
                FOUNDED: state.founded.value,
                HEADQUARTERS: state.headquarters.value,
                ABOUT_COMPANY: state.aboutCompany.value,
                CONTACT_PERSON_DESIGNATION: state.contactPersonDesignation.value,
                FAX_NUMBER: state.faxNumber.value,
                PINCODE: state.pinCode.value,
                EMPLOYER_CATEGORY: state.companyCategory.value,
                COMPANY_TYPE_ID: state.companyType.value,
                MOBILE: state.mobile.value,
            };
            onSubmit(model)
        }
    };
    useEffect(() => {
        editProfileFormData().then((res) => {
            if (res.status) {
                setOptions(state.role.name, res.result.list1);
                setOptions(state.companyType.name, res.result.list2);
                setOptions(state.industryType.name, res.result.list);
            }
        });
    }, [])
    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-12'>
                    <div className={`${styles['profile-cards']}`}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <h2 className="mb-3">Edit Profile</h2>
                            <a className={`${styles['submit-btn']} btn`} href={constant.component.viewProfile.url}><FontAwesomeIcon icon={faEye} className='pe-2' />View Profile</a>
                        </div>
                        <hr />
                        <div className={`${styles['forms-card']}`}>
                            <div className='border rounded-3 p-2 mb-3'>
                                <div className={`${styles['inner-title']}`}>
                                    Contact Details
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label htmlFor="primaryEmail" className={`${styles['label-ct']} form-label`}>
                                            Primary Email <span className="text-danger">*</span>
                                        </label>
                                        <input type="email" id="primaryEmail" placeholder="Enter primary email"
                                            className={!state.primaryEmail.value && state.primaryEmail.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.primaryEmail.name}
                                            value={state.primaryEmail.value}
                                            onChange={handleChange}

                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="secondaryEmail" className={`${styles['label-ct']} form-label`}>
                                            Secondary Email <span className="text-danger">*</span>
                                        </label>
                                        <input type="email" id="secondaryEmail" placeholder="Enter secondary email"

                                            className={!state.secondryEmail.value && state.secondryEmail.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.secondryEmail.name}
                                            value={state.secondryEmail.value}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="mobileNumber" className={`${styles['label-ct']} form-label`}>
                                            Mobile Number <span className="text-danger">*</span>
                                        </label>
                                        <PhoneInput
                                            style={{ height: '36px' }}
                                            className={!state.mobile.value && state.mobile.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.mobile.name}
                                            value={state.mobile.value}
                                            type="text"
                                            defaultPhone="Telephone"
                                            onChange={(phone) =>
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    mobile: {
                                                        ...prevState.mobile,
                                                        value: phone,
                                                    },
                                                }))
                                            }

                                            placeholder="Mobile"
                                            maxLength={11}
                                            id="mobileNumber"
                                            defaultCountry="IN"

                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="border rounded-3 p-2 mb-3">
                                <div className={`${styles['inner-title']}`}>
                                    Logo and Background Header
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label htmlFor="Logo" className={`${styles['label-ct']} form-label`}>
                                            Logo <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type='file'
                                            id='Logo'
                                            className={
                                                !state.companyLogo.value && state.companyLogo.error.length > 0
                                                    ? "form-control is-invalid"
                                                    : "form-control"
                                            }

                                            name={state.companyLogo.name}
                                            onChange={onPictureUpload}
                                        />
                                        {data ? (
                                            <a
                                                target="_blank"
                                                href={`${process.env.REACT_APP_BASE_URL}/company/logo/${data.COMPANY_LOGO}`}
                                            >
                                                {data.COMPANY_LOGO}
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="Header" className={`${styles['label-ct']} form-label`}>
                                            Header Backround
                                        </label>
                                        <input type="file" id="Header"
                                            className={!state.companyHeaderBackground.value && state.companyHeaderBackground.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.companyHeaderBackground.name}
                                            onChange={onHeaderUpload} />

                                        {data ? (
                                            <a
                                                target="_blank"
                                                href={`${process.env.REACT_APP_BASE_URL}/company/header-background/${data.COMPANY_HEADER_BACKGROUND}`}
                                            >
                                                {data.COMPANY_HEADER_BACKGROUND}
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="border rounded-3 p-2 mb-3">
                                <div className={`${styles['inner-title']}`}>
                                    Company Details
                                </div>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label htmlFor="role" className={`${styles['label-ct']} form-label`}>
                                            Role <span className="text-danger">*</span>
                                        </label>
                                        <select

                                            id='role'
                                            className={
                                                !state.role.value && state.role.error.length > 0
                                                    ? "form-select is-invalid"
                                                    : "form-select"
                                            }

                                            name={state.role.name}
                                            value={state.role.value}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Role</option>
                                            {state.role.options &&
                                                state.role.options.map(function (
                                                    item,
                                                    index
                                                ) {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={item.EMPLOYER_ROLE_ID}
                                                        >
                                                            {item.EMPLOYER_ROLE}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="companyName" className={`${styles['label-ct']} form-label`}>
                                            Company Name <span className="text-danger">*</span>
                                        </label>
                                        <input type="text" id="companyName" placeholder="Enter company name"
                                            className={!state.companyName.value && state.companyName.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.companyName.name}
                                            value={state.companyName.value}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="companyCategory" className={`${styles['label-ct']} form-label`}>
                                            Company Category <span className="text-danger">*</span>
                                        </label>
                                        <select className={!state.companyCategory.value && state.companyCategory.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                            name={state.companyCategory.name}
                                            value={state.companyCategory.value}
                                            onChange={handleChange} id="companyCategory">
                                            <option value="">Select Company Category</option>
                                            <option value="COMPANY">Company</option>
                                            <option value="CONSULTANT">
                                                Consultant
                                            </option>
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="companyType" className={`${styles['label-ct']} form-label`}>
                                            Company Type <span className="text-danger">*</span>
                                        </label>
                                        <select id="companyType"
                                            className={!state.companyType.value && state.companyType.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                            name={state.companyType.name}
                                            value={state.companyType.value}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Company Type</option>
                                            {state.companyType.options &&
                                                state.companyType.options.map(function (
                                                    item,
                                                    index
                                                ) {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={item.COMPANY_TYPE_ID}
                                                        >
                                                            {item.COMPANY_TYPE}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="industry" className={`${styles['label-ct']} form-label`}>
                                            Industry <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            id="industry"
                                            className={!state.industryType.value && state.industryType.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                            name={state.industryType.name}
                                            value={state.industryType.value}
                                            onChange={handleChange}>
                                            <option>Select Industry Type</option>
                                            {state.industryType.options &&
                                                state.industryType.options.map(function (
                                                    item,
                                                    index
                                                ) {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={item.EMPLOYER_INDUSTRY_ID}
                                                        >
                                                            {item.INDUSTRY}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="location" className={`${styles['label-ct']} form-label`}>
                                            Location <span className="text-danger">*</span>
                                        </label>
                                        <input type="text" id="location" placeholder="Enter location"
                                            className={!state.location.value && state.location.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.location.name}
                                            value={state.location.value}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="pincode" className={`${styles['label-ct']} form-label`}>
                                            Pincode <span className="text-danger">*</span>
                                        </label>
                                        <input type="text" id="pincode" placeholder="Enter pincode"
                                            className={!state.pinCode.value && state.pinCode.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.pinCode.name}
                                            value={state.pinCode.value}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="contactPerson" className={`${styles['label-ct']} form-label`}>
                                            Contact Person <span className="text-danger">*</span>
                                        </label>
                                        <input type="text" id="contactPerson" placeholder="Enter contact person name"

                                            className={!state.contactPerson.value && state.contactPerson.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.contactPerson.name}
                                            value={state.contactPerson.value}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="designation" className={`${styles['label-ct']} form-label`}>
                                            Designation <span className="text-danger">*</span>
                                        </label>
                                        <input type="text" id="designation" placeholder="Enter Designation"

                                            className={!state.contactPersonDesignation.value && state.contactPersonDesignation.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.contactPersonDesignation.name}
                                            value={state.contactPersonDesignation.value}
                                            onChange={handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="border rounded-3 p-2 mb-3">
                                <h3 className={`${styles['inner-title']}`}>Profile Information</h3>
                                <form>
                                    <div className='row'>
                                        <div className="col-md-4 mb-3">
                                            <label className={`${styles['label-ct']} form-label`}>Company Size *</label>
                                            <input type="col-md-4 text" className={!state.companySize.value && state.companySize.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                name={state.companySize.name}
                                                value={state.companySize.value}
                                                onChange={handleChange} placeholder="Enter company size" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className={`${styles['label-ct']} form-label`}>Founded Year *</label>
                                            <input type="number"
                                                className={!state.founded.value && state.founded.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                name={state.founded.name}
                                                value={state.founded.value}
                                                onChange={handleChange}
                                                defaultValue="2024" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className={`${styles['label-ct']} form-label`}>Headquarters *</label>
                                            <input type="text" className={!state.headquarters.value && state.headquarters.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                name={state.headquarters.name}
                                                value={state.headquarters.value}
                                                onChange={handleChange} placeholder="Enter headquarter place" />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className={`${styles['label-ct']} form-label`}>Website *</label>
                                        <div className='d-flex align-items-center justify-content-center'>
                                            <FontAwesomeIcon className='me-1 fs-2' icon={faGlobe} /><input type="url" className={!state.websiteUrl.value && state.websiteUrl.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                name={state.websiteUrl.name}
                                                value={state.websiteUrl.value}
                                                onChange={handleChange} placeholder="Enter website URL" />
                                        </div>
                                    </div>
                                    <label className={`${styles['label-ct']} form-label`}>Social Media *</label>
                                    <div className="mb-3">
                                        <div className='d-flex align-items-center justify-content-center'>
                                            <img src={Facebook} className='me-2 h2' />
                                            <input type="url" placeholder="www.facebook.com/"

                                                className={!state.facebookPageUrl.value && state.facebookPageUrl.error.length > 0 ? "form-control is-invalid mb-2" : "form-control mb-2"}
                                                name={state.facebookPageUrl.name}
                                                value={state.facebookPageUrl.value}
                                                onChange={handleChange} />
                                        </div>
                                        <div className='d-flex align-items-center justify-content-center'>
                                            <img src={Twitter} className='me-2 h2' />
                                            <input type="url"
                                                className={!state.twitterUrl.value && state.twitterUrl.error.length > 0 ? "form-control is-invalid mb-2" : "form-control mb-2"}
                                                name={state.twitterUrl.name}
                                                value={state.twitterUrl.value}
                                                onChange={handleChange}
                                                placeholder="www.twitter.com/" />
                                        </div>
                                        <div className='d-flex align-items-center justify-content-center'>
                                            <img src={Linkedin} className='me-2 h2' />
                                            <input type="url" placeholder="www.linkedin.com/in/"
                                                className={!state.linkedinProfileUrl.value && state.linkedinProfileUrl.error.length > 0 ? "form-control is-invalid mb-2" : "form-control mb-2"}
                                                name={state.linkedinProfileUrl.name}
                                                value={state.linkedinProfileUrl.value}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        {/* <textarea placeholder="Enter about company"
                                                className="form-control"
                                                name={state.aboutCompany.name}
                                                value={state.aboutCompany.value}
                                                onChange={handleChange}
                                                maxLength={1000}
                                            ></textarea>
                                            <small className="text-muted">  {1000 - (state.aboutCompany.value?.length || 0)}/1000 Characters Left</small> */}
                                        <ReactQuill
                                            value={state.aboutCompany.value}
                                            onChange={(value) => {
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    ['aboutCompany']: {
                                                        ...prevState['aboutCompany'],
                                                        value: value,
                                                    },
                                                }));
                                            }}
                                            placeholder="Enter about company"
                                            modules={{
                                                toolbar: [
                                                    [{ header: [1, 2, false] }],
                                                    ["bold", "italic", "underline"],
                                                    [{ list: "ordered" }, { list: "bullet" }],
                                                    ["link"],
                                                    ["clean"]
                                                ],
                                            }}
                                        />
                                        <small className="text-muted">
                                            {1000 - (state.aboutCompany.value?.length || 0)}/1000 Characters Left
                                        </small>
                                    </div>
                                </form>
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button type="button" className={`${styles['cancel-btn']} btn me-2`}>
                                    Cancel
                                </button>
                                <button type="submit"
                                    onClick={() => {
                                        handleSubmit()
                                    }}
                                    className={`${styles['submit-btn']} btn`}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditProfile